import FlexContainer from 'components/FlexContainer';
import { ClaimReferenceItem } from 'features/fact-grabbing/ClaimReferenceItem';
import { ScrollToTopButton } from 'features/fact-grabbing/ScrollToTopButton';
import { useRef } from 'react';
import { ClaimReference } from 'services/backofficeIntegration/http/endpoints/fact-grabbing/httpSearchReferencesByClaim';
import styled from 'styled-components';

type Props = {
  references: ClaimReference[];
};

export const ClaimReferenceList = ({ references }: Props) => (
  <Root>
    {references.map(reference => (
      <ClaimReferenceItem key={reference.id} reference={reference} />
    ))}
  </Root>
);

const Root = styled(FlexContainer).attrs({
  direction: 'column',
  gap: 'three'
})`
  // Required to better visually align the reference icons with the legend above
  padding-left: 4px;
`;
